import envconfig from './EnvConfig';

/**
 * 合作伙伴门户地址
 * @param url
 */
const businessUrl = (url: string): string => {
  return envconfig.server.business + '/user/business' + url;
};

const userUrl = (url: string): string => {
  return envconfig.server.business + url;
};

/**
 * 主域名地址
 * @param url
 */
const domainUrl = (url: string): string => {
  return envconfig.server.domain + '/api/' + envconfig.server.apiVersion + url;
};

const domainApi = (url: string): string => {
  return envconfig.server.domain + url;
};

/**
 * 管理平台门户地址
 * @param url
 */
const clinicUrl = (url: string): string => {
  return envconfig.server.clinic + '/api/' + envconfig.server.apiVersion + url;
};

/**
 * 规则集门户地址
 * @param url
 */
const ruleUrl = (url: string): string => {
  return envconfig.server.domain + '/rule' + url;
};

/**
 * 规则集门户地址
 * @param url
 */
const accountUrl = (url: string): string => {
  return envconfig.server.domain + '/account/' + url;
};

/**
 * flex地址
 * @param url
 */
const flexUrl = (url: string): string => {
  return envconfig.server.domain + '/flex/' + url;
};

/**
 * websocket
 * @param url
 */
const webSocketUrl = (url: string): string => {
  return envconfig.server.websocket + url;
};

const webUrl = (url: string): string => {
  return envconfig.server.web + url;
};

/**
 * API地址集合
 */
const APIS = {
  businessUrl,
  userUrl,
  domainUrl,
  clinicUrl,
  ruleUrl,
  webSocketUrl,
  webUrl,
  accountUrl,
  flexUrl,
  domainApi,
  login: '/login/',
  /** 手机获取验证码 */
  verifyCodeMobile: '/password/reset-by-mobile/start/',
  /** 手机重置密码 */
  resetPasswordMobile: '/password/reset-by-mobile/finish/',
  /** 邮箱获取验证码 */
  verifyCodeEmail: '/password/reset-by-email/start/',
  /** 邮箱重置密码 */
  resetPasswordEmail: '/password/reset-by-email/finish/',
  logout: '/user/logout',
  // 当前登录代理商信息
  agentSelf: '/hosp/agent/self/',
  // 大陆省份
  province: '/location/',
  // 国外+港澳台地区
  country: '/country/',
  // 地区（省市区）
  locationArea: '/location-export/',
  // agentDoctor: '/hosp/agent/doctor/',
  agentDoctors: '/hosp/agent/doctors/',
  // agentDoctorCertification: '/hosp/agent/doctor-certification/',
  // /** 审核已驳回的医生列表 */
  // agentDoctorRejected: '/hosp/agent/rejected-doctors/',
  doctor: {
    legacyMembers: '/doctor/legacy/doctors/members/', // 医生和机构关联的接口(兼容)
    members: '/doctor/doctors/members/', // 医生和机构关联的接口
    institutions: '/doctor/institutions/', // 机构相关接口
    doctors: '/doctor/doctors/', // 医生相关接口
    doctorCertification: '/doctor/doctors/certifications/', // 医生认证接口
  },
  // 配药中心
  drugStore: '/hosp/agent/drug-stores/',
  // 当前登录的配药中心
  drugStoreSelf: '/hosp/agent/drug-stores/self/',
  /** 药品（处方）订单 */
  drugStoreOrder: '/hosp/agent/drug-store-orders/',
  /** 药品（处方）订单列表 */
  drugStoreOrderList: '/hosp/agent/light-drug-store-orders/',
  /** 订单的发票 */
  drugStoreInvoice: '/hosp/agent/drugorder-invoices/',
  /** 操作订单 */
  drugOrderOp: '/hosp/agent/drugorder-operations/',
  /** 省市区地址 */
  location: '/location-name/',
  /** 用户角色 */
  userRoles: '/user/roles/',
  /** 任务状态接口 */
  taskStatus: '/task_manager/task_status/',
  /** 用户管理操作员查看列表接口 */
  userAdminList: '/user/business/staff/',
  /** 用户管理操作员添加接口 */
  userAdminAdd: '/hosp/partner-staff-signup/',
  /** 充值订单选项接口 */
  rechargeOption: '/hosp/agent/value-added-service-packages/',
  /** 7天增值服务剩余册数接口 */
  docRechargeSevenDay: '/hosp/justfy-sevenly-limit/',

  agent: {
    /** 开具和取消开具的发票操作 */
    invoiceOperation: '/hosp/agent/drugorder-invoice-operations/',
  },
  // /** 查询诊所接口 */
  // hospotals: '/hosp/hospitals/',
  /** 医生批量关联配药中心 */
  batchLinkDrugstore: '/hosp/agent/doctors-batch/link-drugstore/',
  /** 药品改价相关接口 */
  priceChange: {
    /** 改价申请 */
    priceAdjustmentApplication: '/mall/medicine/price-adjustment-application/',
    /** 改价申请药品详情 */
    priceAdjustmentItem: '/mall/medicine/price-adjustment-item/',
    /** 获取申请条目 */
    priceWaitingApprove: '/mall/medicine/sku/price-adjustment-waiting-approve/',
  },
  /** mall服务相关接口 */
  mall: {
    /** 物流 */
    express: '/mall/express/',
    /** 药库 */
    pharmacy: '/mall/medicine/groups/',
    /** 价格模式 */
    pricePolicy: '/mall/medicine/price-policies/',
    /** 品牌/药厂 */
    brand: '/mall/medicine/brands/',
    /** 类目 */
    category: '/mall/categories/',
    /** 中药（标准）接口 */
    medicineSPU: '/mall/spu/',
    /** 中药（库存）接口 */
    medicineSKU: '/mall/medicine/sku/',
    /** 中药批量上架接口 */
    batchMedicineSKU: '/mall/medicine/sku/batch-active/',
    /** 西成药（库存）接口 */
    westernSku: '/mall/western/sku/',
    /** 西成药批量上架接口 */
    batchWesternSku: '/mall/western/sku/batch-active/',
    /** 西成药批量改价 */
    westernSkuUpdatePrice: '/mall/western/sku/west-price-update/',
    /** 药品导入 */
    medicineImport: '/mall/medicine/sku/import/',
    /** 药品导出 */
    medicineExport: '/mall/medicine/partner/sku/export/',
    /** 西成药药品导入 */
    westernMedImport: '/mall/western/sku/cooperation-import/',
    /** 西成药药品导出 */
    westernMedExport: '/mall/western/sku/cooperation-export',
    /** 云药房-药库设置（代理商医生） */
    cloudPharmacySetting: '/mall/medicine/buyer/groups/cloud/',
    /** 本地药房-药库设置（代理商医生） */
    localPharmacySetting: '/mall/medicine/buyer/groups/local/',
    /** 西成药 本药房-药库设置（） */
    localCpmPharmacySetting: '/mall/western/west_local/',
    // 医生的默认药库配置
    doctorMedicineConfig: '/mall/medicine/buyer/medicine-config/',
    /** 药典列表 */
    medicineCatLog: '/mall/western/medicine-cat-log/',
    /** 药品单位字典 */
    medicintUnitDict: '/mall/unit/catalog/light/'
  },
  /** mall-edi服务相关接口 */
  mallEdi: {
    /** 订单信息（处方）推送 */
    sendOrder: '/mall-edi/notification/self/orders/',
    /** 发送订单配置 */
    sendConfig: '/mall-edi/notification/self/',
  },
  /** 拼音 */
  pinyin: '/pinyin/',
  /** 快递配置信息 */
  expressConfig: '/mall/express/companies/',
  /** 部门管理 */
  departmentAdmin: {
    /** 部门[增|删|改|查] */
    department: '/partner/departments/',
    /** 部门人员[增|删|改|查] */
    staff: '/partner/members/'
  },
  /** 处方订单或药品订单导出接口 （由后端导出） */
  exportDrugOrderList: '/hosp/agent/light-drug-store-orders/export-drug-order-list/',
  /** 导出订单详情 */
  exportDrugOrderDetailList: '/hosp/agent/light-drug-store-orders/export-drugs/',
  /** 促销[启用|禁用]设置 */
  promotion: {
    status: '/api/v1/hosp/promotion-active/',
    list: '/api/v1/hosp/promotion-policies/',
    verifyCode: '/api/v1/hosp/promotion-send/',
  },
  /** 记账机构管理相关接口 */
  bookKeepingAdmin: {
    /** 记账关联[增删改] */
    bookKeeping: '/api/v1/hosp/agent/drug-store-bookkeeping-institutions/',
    /** 配药中心关联机构查询 */
    institution: '/doctor/institutions/by-drug-store/',
  },
  /** 分润配置 */
  TransactionSettings: `/hosp/transaction-settings/`,
  /** 基础数据 */
  ruleDraft: {
    /** 西成药 服用单位 */
    westTakeUnit: '/rule-draft/western/take-unit/',
    /** 西成药 剂型 */
    westDosageForm: '/rule-draft/western/dosage-form/',
    /**  西成药 给药途径 */
    westDosageRoute: '/rule-draft/western/dosage-route/',
    /** 西成药 用药频率 */
    westMedicationFrequency: '/rule-draft/western/medication-frequency/',
    /** 脉景品名 */
    queryProductMap: `/rule-draft/cpms/light/`,
    /** 特殊用法 */
    takeMethods: '/rule-draft/takemethods/',
  },
  /** 退款 */
  refundOrder: '/hosp/order/refund-orders/',
  /**
   * OSS/合作伙伴给医生或者机构增加后台VIP订单
   * https://yapi.macrocura.com/project/84/interface/api/5581
   */
  'backend-orders': '/purchase/backend-orders/',
  /** 导出药品发货清单 */
  'export-deliver-list': '/hosp/agent/light-drug-store-orders/export-deliver-list/'
};

export default APIS;



// WEBPACK FOOTER //
// ./src/constants/ApiConfig.ts